export default {
  getUserById: (state) => (id) => {
    return state.users.find(user => user.id === id)
  },
  getUserProfile: (state, getters) => (id) => {
    const user = getters.getUserById(id)
    if (user) {
      return user.profile
    } else {
      return {}
    }
  }
}
